import Label from "lib/Label";
import { Col,Row } from "react-bootstrap";
import "./index.scss";
import ErrorMessage from "lib/ErrorMessage";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import {
  setEditIndex,
  setEditSaveData,
  setRecursiveFormData,
} from "redux/fieldRecursiveReducer";
const InputGroup = (props) => {
  const {
    id,
    placeholder,
    label,
    index,
    value,
    req_type,
    onChange,
    onCheckBoxChange,
    type,
    name,
    class_name,
    size,
    error,
    events,
    value1
  } = props;

  const errActive = error && error?.length !== 0;
  const errorClass = errActive ? "error_outline" : "";

  // const [isChecked, setIsChecked] = useState(true);
  // const [textValue, setTextValue] = useState(value);

  const copiedData = useSelector((state) => state.formData.copiedData);

  const editIndex = useSelector((state) => state.recursive.editIndex);
  const dispatch = useDispatch();

  const handleCheckboxChange = (e) => {
    onChange(id, {text: value?.text , is_required : e.target.checked});
  };
  const hanldeOnChange = (e) => {
    onChange(id, {text: e.target.value , is_required : value?.is_required ? value?.is_required : false});
  };
  const handleFocus = () => {
  };
  return (
  
      <div className={size}>
      <div className="mb-3 input-group">
        <input
          aria-label="Text input with checkbox"
          className={`form-control ${`form-input`} `}
          name={name}
          placeholder={placeholder}
          value={value?.text ? value?.text : ''}
          onChange={hanldeOnChange}
          onFocus={handleFocus}
        />
        <span className="input-group-text">
          <input
            aria-label="Checkbox for following text input"
            type="checkbox"
            name={name}
            className="form-check-input mt-0"
            checked={value?.is_required}
            onChange={handleCheckboxChange}
          />
        </span>
      </div>

      {error?.length !== 0 && <ErrorMessage error={error} />}
    </div>
  
  );
};

export default InputGroup;
